import { render, staticRenderFns } from "./CsimVisitPeriodModel.vue?vue&type=template&id=47c827be&scoped=true"
import script from "./CsimVisitPeriodModel.vue?vue&type=script&lang=js"
export * from "./CsimVisitPeriodModel.vue?vue&type=script&lang=js"
import style0 from "./CsimVisitPeriodModel.vue?vue&type=style&index=0&id=47c827be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c827be",
  null
  
)

export default component.exports